import React from 'react';
import PropTypes from 'prop-types';

// import { 
//   Redirect,
//                   } from 'react-router-dom';

import { 
  Logger,
                  } from 'aws-amplify';

import {
  Button,
  Dialog,
  useMediaQuery,
                  } from '@material-ui/core';

import { 
  useTheme,
                  } from '@material-ui/core/styles';

import { 
  Alert, 
  AlertTitle,
                  } from '@material-ui/lab';

const logger = new Logger('SessionDialog');

export default function SessionDialog(props) {
  const { open, onClose } = props;

  const [redirected, setRedirected] = React.useState(null);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const title="Session Expired";

  const handleSignout = () => {
    setRedirected('/');
  };
  
  const handleContinue = () => {
    const targetUrl="https://login.nextcloud.aero?returnTo="+window.location.href;
    logger.debug("REAUTH AND CONTINUE URL: ",targetUrl);
    window.location=targetUrl;
  };

  if(redirected) {
    window.location.reload();
    //return <Redirect push to={redirected} />;  
  }
  
  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        aria-labelledby="responsive-dialog-title"
      >
          <Alert severity="error">
            <AlertTitle>{title}</AlertTitle>
            Your console session has expired.  You must re-authenticate to 
            continue using the console.
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline'}}>
              <Button color="inherit" size="small" onClick={handleSignout}>
                SIGNOUT
              </Button>
              or
              <Button color="inherit" size="small" onClick={handleContinue}>
                CONTINUE
              </Button>
            </div>
          </Alert>
      </Dialog>
    </div>
  );
}

SessionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

